import { i18n } from '@/plugins/i18n'

/**
 * These are the fields that are required for the register device template.
 * These should not be localized as they map to the column headers in the template that the user downloads.
 * The validation will check for these exact column headers when validating the file.
 */
export const registerDeviceTemplateFields = {
  deviceName: 'Device Name',
  locationName: 'Location Name',
  deviceSerialNumber: 'Device Serial Number',
  makeDevicePublic: 'Make Device Public?',
  indoorSensor: 'Indoor Sensor?',
  latitude: 'Latitude',
  longitude: 'Longitude'
} as const

export const registerDeviceValidationErrors = {
  deviceName: i18n.global.t('registerMultipleDevices.validationErrors.deviceName'),
  locationName: i18n.global.t('registerMultipleDevices.validationErrors.locationName'),
  deviceSerialNumber: i18n.global.t('registerMultipleDevices.validationErrors.deviceSerialNumber'),
  indoorSensor: i18n.global.t('registerMultipleDevices.validationErrors.indoorSensor'),
  latitude: i18n.global.t('registerMultipleDevices.validationErrors.latitude'),
  longitude: i18n.global.t('registerMultipleDevices.validationErrors.longitude'),
  nullIsland: i18n.global.t('registerMultipleDevices.validationErrors.nullIsland'),
  blankFile: i18n.global.t('registerMultipleDevices.validationErrors.blankFile'),
  columnHeaders: i18n.global.t('registerMultipleDevices.validationErrors.columnHeaders')
} as const
